type Trigger = "enter" | "middle";
type Effect = "fade" | "slide" | "revealWidth";
type From = "left" | "right" | "center" | "up" | "down";

export type ScrollFxOptions = {
  trigger?: Trigger;
  effect?: Effect;
  from?: From;
  once?: boolean;
  threshold?: number;
  band?: number; // for middle trigger
};

export function scrollFx(options: ScrollFxOptions = {}) {
  const {
    trigger = "enter",
    effect = "fade",
    from = "center",
    once = true,
    threshold = 0,
    band = 0.2,
  } = options;

  return {
    "data-scrollfx": "true",
    "data-scrollfx-trigger": trigger,
    "data-scrollfx-effect": effect,
    "data-scrollfx-from": from,
    "data-scrollfx-once": once ? "true" : "false",
    "data-scrollfx-threshold": String(threshold),
    "data-scrollfx-band": String(band),
  } as const;
}
